<div class="jhm-modal-background">
	<div id="create-contact-modal" class="jhm-modal create-contact-modal">
		<button class="jhm-icon-button transparent close-modal-button" (click)="cancel()"><i class="fa-regular fa-times"></i></button>
	  <header>
			<div class="title">
				<h2>Add New Contact</h2>
			</div>
	  </header>
	  <div class="edit-body">
			<div class="form-section">
			<div class="form-item">
			  <div class="input-title">Inmate Jurisdiction</div>
				<mat-form-field class="time-select">
					<mat-select [(ngModel)]="selectedJurisdictionId" (selectionChange)="jurisdictionChanged($event); checkIfCanSubmit()">
						@for (jurisdiction of jurisdictionOptions; track jurisdiction.id) {
							<mat-option value={{jurisdiction.id}}>{{jurisdiction.name}}</mat-option>
						}
					</mat-select>
				</mat-form-field>
			</div>
			@if (selectedJurisdiction?.lookupUrl) {
				<div class="additional-info">
					If there is unknown information, you can look up inmates at {{selectedJurisdiction.name}} <a href="{{selectedJurisdiction.lookupUrl}}" target="_blank">here</a>.
				</div>
			}

			<div class="form-item">
			  <div class="input-title">First Name</div>
			  <mat-form-field appearance="outline">
				<input matInput [(ngModel)]="firstName" placeholder="First Name" (change)="checkIfCanSubmit()">
			  </mat-form-field>
			</div>
			<div class="form-item">
			  <div class="input-title">Last Name</div>
			  <mat-form-field appearance="outline">
				<input matInput [(ngModel)]="lastName" placeholder="Last Name" (change)="checkIfCanSubmit()">
			  </mat-form-field>
			</div>
			<div class="form-item">
			  <div class="input-title">Booking Number</div>
			  <mat-form-field appearance="outline">
				<input matInput [(ngModel)]="bookingNumber" placeholder="Booking Number" (change)="checkIfCanSubmit()">
			  </mat-form-field>
			</div>
			<div class="form-item">
			  <div class="input-title">Birth Date</div>
			  <mat-form-field appearance="outline">
				<input matInput placeholder="Select a date..." [matDatepicker]="dateOfBirthPicker" [(ngModel)]="birthDate" (dateChange)="dateChanged('BIRTH'); checkIfCanSubmit()" />
				<mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"></mat-datepicker-toggle>
				<mat-datepicker #dateOfBirthPicker></mat-datepicker>
			  </mat-form-field>
			</div>
			<div class="form-item">
			  <div class="input-title">Booked Date</div>
			  <mat-form-field appearance="outline">
				<input matInput placeholder="Select a date..." [matDatepicker]="bookedDatePicker" [(ngModel)]="bookedDate" (dateChange)="dateChanged('BOOKED'); checkIfCanSubmit()" />
				<mat-datepicker-toggle matSuffix [for]="bookedDatePicker"></mat-datepicker-toggle>
				<mat-datepicker #bookedDatePicker></mat-datepicker>
			  </mat-form-field>
			</div>
		  </div>
	  </div>
	  <footer class="filled">
		<button class="jhm-button" (click)="cancel()">Cancel</button>
		<button [class.disabled]="!canSubmit" class="jhm-button primary" (click)="createContact()">Create</button>
	  </footer>
	</div>
  </div>